import { featureFlags } from '@melio/shared-web';
import { UseFeatureOptions } from '@melio/shared-web/dist/feature-flags';

export enum FeatureFlags {
  MultiOrgUI = 'platform-multi-org-ui',
  AccountManagerAccessCollaborators = 'am-access-collaborators-list',
  BatchPayments = 'channels-batch-payments',
  CombinedPayments = 'channels-combined-payments',
  JustPay = 'channels-enable-just-pay',
  VaultingTokenProvider = 'vaulting-token-provider',
  ExportPaymentsMultipleFormats = 'exoport-payments-multiple-formats',
  USHolidaysChecks = 'us-holidays-checks-partners',
  DashboardEmptyState = 'platform-dashboard-empty-state',
  NotificationPreferences = 'platform-notification-preferences',
  FeedbackWidget = 'feedback-widget-platform',
  RecurringPayments = 'recurring-payments-platform',
  SyncNow = 'platform-sync-now',
  NpeFirstTimeExperience = 'platform-npe-fte',
  IsInternationalDeliveryMethodSupported = 'platform-international-payments-web',
  IsConvertToCorrectTimeAuthEnabled = 'is-convert-to-correct-time-auth-enabled',
  SplitContactsTab = 'split-contacts-tab',
  ExpandingFormSearch = 'platform-expanding-form-search',
  MarkAsPaid = 'platform-mark-as-paid',
  PayUnpaidBills = 'enable-pay-unpaid-bills',
  TimelineTrackerEnabled = 'platform-timeline-tracker-enabled',
  NetworkVendorSupport = 'platform-network-vendor-support',
  DisplayVendorAsFreeTextInstantBill = 'display-vendor-as-free-text-instant-bill',
  PartialPaymentsEnabled = 'platform-partial-payments',
  DisplayReceivingMethodsItem = 'display-platform-settings-receiving-methods',
  SwitchToZendeskChat = 'switch-to-zendesk-chat',
  CheckFeesPromotionEnabled = 'partnerships-free-checks',
  RequestADemo = 'request-a-demo',
  CustomCheckAddressEnabled = 'platform-custom-check-address-enabled',
  IsUnilateralEnrollmentEnabled = 'msn-unilatral-and-enrollment',
  UnilateralPaperCheckAddressFlow = 'unilateral-platform-papercheck-address-flow',
  CapOnePortalBackToL3 = 'capone-portal-back-to-l3',
  isCapOnePortalEnabled = 'is-capone-portal-enabled',
  ShouldIndustryBePartOfLegalInfo = 'should-industry-be-part-of-legal-info',
  RobinhoodRefundFlow = 'partnerships-robinhood-refund-flow',
  IsInternationalSupportedForRecurringFlow = 'platform-international-payments-recurring',
  ARDashboard = 'ar-dashboard',
  PlatformFinancing = 'platform-financing',
  UseDeliveryDateSchedulingPreference = 'use-delivery-date-scheduling-preference',
  SelectDeliveryDateFeatureEnabled = 'select-delivery-date-feature-enabled',
  EnableUpsellInPlatformUI = 'enable-upsell-in-platform-ui',
  IsSpendManagementEnabled = 'is-spend-management-enabled',
  IsPayDashboardTourEnabled = 'Platform-enable-pay-dashboard-tour',
  IsDeliveryDateTourEnabled = 'platform-enable-delivery-date-tour',
  ApprovalWorkflows = 'platform-approval-workflows',
  PlatformMultipleBillsUpload = 'platform-multiple-bills-upload',
  IsVirtualCardSupported = 'platform-virtual-card',
  IsSearchBusinessesInDirectoriesSupported = 'is-search-businesses-in-directories-supported',
  CloverFreeAchPromotion = 'clover-free-ach-promotion',
  AddCompanyEnabled = 'platform-multi-org-web-add-company',
  isSupportingSuvcAcceptance = 'platform-support-virtual-card-acceptance',
  UseOrganizationsEndpointForCompaniesList = 'platform-use-organizations-endpoint-for-companies-list',
  FetchPaymentActionsOnDashboard = 'fetch-payment-actions-on-dashboard',
  JustPayV2Recurring = 'platform-just-pay-v2-recurring',
  RtpPayorEnabledForBatchPayments = 'rtp-payor-batch-payments',
  FTEChangesForOrgsConnectedToAccountingPlatform = 'platform-fte-changes-for-connected-to-accounting-orgs',
  qboUpcomingBillsReminderPartnerships = 'qbo-upcoming-bills-reminder-partnerships',
  BillingFees = 'platform-billing-fees',
  EBills = 'platform-ebills',
  AddDeliveryDateToCreateAndUpdatePayment = 'add-delivery-date-to-create-and-update-payment',
  IsEngagementProvider = 'is-engagement-provider',
  MessagingAccountCentricViewCase = 'messaging-account-centric-view-case',
  PlatformXeroAccountingSoftwareEnabled = 'platform-xero-accounting-software-enabled',
  PlatformFinancingApplicationFlow = 'platform-financing-application-flow',
  PlatformFinancingApplicationFlowUBO = 'platform-financing-application-flow-beneficial-owners',
  PlatformFinancingApplicationFlowFromPayment = 'platform-financing-application-flow-from-payment',
  EditApprovalWorkflowEnabled = 'platform-approval-workflows-edit',
  NewDashboardSchedulePaymentCTA = 'platform-app.ap.new-dashboard-schedule-payment-cta',
  AutoPay = 'platform-auto-pay',
  NpeSort = 'platform-npe-sort',
  LineItemsCombineView = 'platform-line-items-combine-view',
  PlatformScheduledPaymentAccountingPlatformSyncPromotion = 'platform-scheduled-payment-account-platform-sync-promotion',
  SbbExclusiveUserView = 'platform-app-sbb-exclusive-user-view',
  NpeSortMobile = 'platform-npe-sort-mobile',
  NPEPaymentFees = 'platform-npe-payment-fees',
  PlatformVendorNameConstraints = 'platform-vendor-name-constraints',
  NewBillEntryPoint = 'new-bill-entry-point',
  ShowPaymentScheduledDisclaimer = 'platform-show-payment-scheduled-disclaimer',
  InAppMarketingEnabled = 'in-app-marketing-enabled',
  BatchDeleteBills = 'platform-batch-delete-bills',
  UnderMaintenance = 'under-maintenance',
  ShowVendorDetailsModalForVisa = 'show-vendor-details-modal-for-visa',
  RestrictBankPaymentDeliveryMethodsEnabled = 'platform-restrict-bank-payment-delivery-methods',
  PlatformVendorsBatchNewPaymentsEnabled = 'platform-vendors-batch-new-payments',
  PlatformFixRefreshAccessTokenEnabled = 'platform-fix-refresh-access-token',
  GetBillFileOcrDataOnBillDetailsScreen = 'get-bill-file-ocr-data-on-bill-details-screen',
  PlatformApprovalWorkflowsV2 = 'platform-approval-workflows-v2',
  MtlKycUplift = 'platform-mtl-kyc-uplift',
  PlatformBillClassesQbo = 'platform-bill-classes-qbo',
  PlatformSubscriptions = 'platform-subscriptions',
  EBillsAmazonEnabled = 'ebills-amazon-enabled',
  EBillsGmailEnabled = 'ebills-gmail-enabled',
  PlatformBillLocations = 'platform-bill-locations',
  GrowthAddCollaboratorsEnabled = 'growth-add-collaborator-enabled',
  GrowthAddPaymentMethodEnabled = 'growth-add-payment-method-enabled',
  ExternalVendorLogoEnabled = 'platform-show-external-vendor-logo',
  NewPaymentScheduledSuccessfully = 'new-payment-scheduled-successfully',
  GrowthRecommendedVendorsExperiment = 'growth-recommended-vendors-experiment',
  PlatformFinancingPaymentFlow = 'platform-financing-payment-flow',
  ContextualOnboardingGmailSyncEnabled = 'platform-contextual-onboarding-gmail-sync-enabled',
  NewPaymentFlow = 'platform-new-payment-flow',
  PlatformSyncMigrationProgressIndication = 'platform-full-sync-progress-indication',
  W9TaxPayerInfo = 'w-9-taxpayer-information',
  FinancingTabToolTipEnabled = 'financing-tab-tooltip-enabled',
  PlatformScheduledPaymentCardToCardPromotionEnabled = 'platform-scheduled-payment-card-to-card-promotion',
  SetAsDefaultPaymentMethodEnabled = 'set-a-default-payment-method-enabled',
  PlatformUserManagementAdjustmentsFiserv = 'platform-user-management-adjustments-fiserv',
}

/*
Please use PascalCase for the new enum names, according to the official typescript documentation page.
Link: https://www.typescriptlang.org/docs/handbook/enums.html
*/

export const useFeature = <T>(flagKey: FeatureFlags, defaultValue: T, options?: UseFeatureOptions) =>
  featureFlags.useFeature(flagKey, defaultValue, options);
export const useAnonymousFeature = <T>(flagKey: FeatureFlags, defaultValue: T, options?: UseFeatureOptions) =>
  featureFlags.useAnonymousFeature(flagKey, defaultValue, options);
